import { getObjectKeysAsObject, ParentState } from "@capone/checkout";

import { SelectTravelerEvent } from "../../../modules/book/state/events";
import {
  ActivityContext,
  ActivityMachineContext,
} from "../../../modules/book/state/types";
import { allSelectedTravelersValid } from "./validation";
import { isCheckoutImprovementsEnabled } from "../../../context/experiments";

export const guards = {
  haveAnyTravelersLoaded: (ctx: ActivityContext) => {
    const { userTravelers } = ctx[ParentState.activityTravelerInformation];
    if (userTravelers?.length && userTravelers.length > 0) {
      return true;
    }
    return false;
  },
  hasAnySelectedTravelers: (ctx: ActivityContext) => {
    const { selectedTravelerIds } =
      ctx[ParentState.activityTravelerInformation];
    return selectedTravelerIds.length > 0;
  },
  // Validates that all selected travelers have all required fields filled
  allSelectedTravelersHaveRequiredFields: (ctx: ActivityContext) =>
    allSelectedTravelersValid(ctx),

  // Combined guard for mobile: validates selected travelers AND checks mobile platform
  allSelectedTravelersValidAndMobile: (ctx: ActivityMachineContext) =>
    allSelectedTravelersValid(ctx) && ctx.platform === "mobile",
  willHaveSelectedTravelers: (
    ctx: ActivityContext,
    event: SelectTravelerEvent
  ) => {
    const { selectedTravelerIds } =
      ctx[ParentState.activityTravelerInformation];
    return !(
      selectedTravelerIds.length === 1 &&
      selectedTravelerIds[0] === event.travelerId
    );
  },
  hasCurrentUserTraveler: (ctx: ActivityContext) => {
    const currentUserTraveler =
      ctx[ParentState.activityTravelerInformation].currentUserTraveler?.id;
    return !!currentUserTraveler;
  },
  notVisitedTraveler: (ctx: ActivityContext) =>
    !ctx[ParentState.activityTravelerInformation].visited,
  notValidated: (ctx: ActivityContext) =>
    !ctx[ParentState.activityTravelerInformation].isValidated,
  hasSelectedPrimaryTraveler: (ctx: ActivityContext) =>
    !ctx[ParentState.activityPrimaryTraveler].selectedPrimaryTravelerId,
  isSingleSelectedTraveler: (ctx: ActivityMachineContext) =>
    isCheckoutImprovementsEnabled(ctx.experiments) &&
    ctx[ParentState.activityTravelerInformation].selectedTravelerIds.length ===
      1,
  isSingleSelectedTravelerWithAdditionalDetails: (ctx: ActivityMachineContext) =>
    isCheckoutImprovementsEnabled(ctx.experiments) &&
    ctx[ParentState.activityTravelerInformation].selectedTravelerIds.length ===
      1 &&
    ctx[ParentState.activityAdditionalDetails].hasAdditionalDetailsStep,
};

export const GuardTypes = getObjectKeysAsObject(guards);
